let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8bVS2"), load("tLGOl")]).then(() => parcelRequire('anKEx'));